// src/utils/storage.js
export class StorageUtil {
  constructor(config = {}) {
    this.config = config || {};
    this.namespace = this.config.namespace || `casino_audit_${this.config.siteId || 'default'}`;
    this.enabled = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }

  _key(key) {
    return `${this.namespace}:${key}`;
  }

  set(key, value, ttlMs = null) {
    if (!this.enabled) return;
    const payload = {
      v: value,
      t: ttlMs ? Date.now() + ttlMs : null
    };
    try {
      localStorage.setItem(this._key(key), JSON.stringify(payload));
    } catch (e) {
      // localStorage might be full or blocked
      // silently ignore for SDK resilience
    }
  }

  get(key) {
    if (!this.enabled) return null;
    try {
      const raw = localStorage.getItem(this._key(key));
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed.t && Date.now() > parsed.t) {
        localStorage.removeItem(this._key(key));
        return null;
      }
      return parsed.v;
    } catch (e) {
      return null;
    }
  }

  remove(key) {
    if (!this.enabled) return;
    try {
      localStorage.removeItem(this._key(key));
    } catch (e) {}
  }

  increment(key, amount = 1) {
    const current = parseInt(this.get(key) || 0, 10) || 0;
    this.set(key, current + amount);
    return current + amount;
  }

  pushRecentAction(action, max = 50) {
    const arr = this.get('recentActions') || [];
    arr.unshift({ action, timestamp: new Date().toISOString() });
    if (arr.length > max) arr.length = max;
    this.set('recentActions', arr);
  }

  clear() {
    if (!this.enabled) return;
    // remove namespaced keys
    try {
      const prefix = `${this.namespace}:`;
      const toRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.indexOf(prefix) === 0) toRemove.push(k);
      }
      toRemove.forEach(k => localStorage.removeItem(k));
    } catch (e) {}
  }
}
